import React from 'react';
import { Box, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ContentBlock } from '../../../types/blocks';

interface HeadingBlockEditorProps {
  block: ContentBlock;
  onChange: (block: ContentBlock) => void;
}

const HeadingBlockEditor: React.FC<HeadingBlockEditorProps> = ({ block, onChange }) => {
  const level = (block.meta?.level as number) || 2;

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
      <TextField
        fullWidth
        placeholder="Heading text..."
        value={block.content}
        onChange={(e) => onChange({ ...block, content: e.target.value })}
        sx={{
          '& .MuiOutlinedInput-root': {
            fontSize: level === 1 ? '1.25rem' : level === 2 ? '1.1rem' : '1rem',
            fontWeight: 600,
          },
        }}
      />
      <ToggleButtonGroup
        value={level}
        exclusive
        onChange={(_, val) => {
          if (val !== null) onChange({ ...block, meta: { ...block.meta, level: val } });
        }}
        size="small"
      >
        <ToggleButton value={1} sx={{ px: 1.5, fontSize: '0.75rem' }}>H1</ToggleButton>
        <ToggleButton value={2} sx={{ px: 1.5, fontSize: '0.75rem' }}>H2</ToggleButton>
        <ToggleButton value={3} sx={{ px: 1.5, fontSize: '0.75rem' }}>H3</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default HeadingBlockEditor;
